<banner-app
  [Fixtop]="''"
  [retroSelected]="false"
  [infoDueno]="true"
  [showPromo]="true"
></banner-app>

<div class="final-page__container">
  <div class="final-page__text-container">
    <p class="final-page__text-title">Error 500 - Error interno del servidor</p>
    
  </div>
  <div class="final-page__image-container">
    <img
      src="./assets/img/ConexionInterrumpida.png"
      class="final-page__image"
      alt="Imagen de no pasa SARLAFT"
      loading="lazy"
    />
  </div>
  <div class="final-page__text-container">
    <!-- <p class="final-page__text-title">Error 500 - Error interno del servidor</p> -->
     <p class="final-page__text-subtitle">
      Estamos experimentando algunos problemas técnicos....
    </p>
 <p class="final-page__text">
     Nuestro equipo está trabajando para restablecer el servicio lo más pronto posible. 
    Recarga la página o vuelve a intentarlo más tarde.

    Mientras tanto, puedes explorar otros de nuestros seguros 
    </p> 
  </div>
  <div class="final-page__button-container">
    <button class="final-page__button" (click)="volverInicio()">Ir a sura.co</button>
  </div>
</div>


<app-footer-app class="footer-fixed" />
